<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow
          routeBack="ResourceIndex"
          :title="getValue('title')"/>
        <show-actions
          :deleteItem="allowDelete && resource && resource.nbSheetLinked === 0"
          :editItem="allowEdit"
          :downloadItem="resource && resource.resourceType==='FILE' && resource.fileRobustagno.id"
          @clickOnDeleteBtn="clickOnDeleteBtn"
          @clickOnDownloadBtn="clickOnDownloadBtn"
          @clickOnEditBtn="clickOnEditBtn">
        </show-actions>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">

            <div class="row">
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('Resource.title') }}</div>
                  <div> {{ getValue('title') }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('Resource.Type') }}</div>
                  <div v-if="resource.resourceType==='FILE' || resource.resourceType==='EXTERNAL_VIDEO_FILE'">{{getValue('fileRobustagno.fileType')}}</div>
                  <div v-else>{{this.$t(resource.resourceType)}}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('Resource.Origin') }}</div>
                  <div> {{ getValue('source') }}</div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="d-flex flex-column mb-4 custom-border">
                </div>
              </div>

              <div class="col-md-6" v-if="resource.resourceType==='FILE' || resource.resourceType==='EXTERNAL_VIDEO_FILE'">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('Resource') }}</div>
                  <img v-if="resource.fileRobustagno.fileType === 'IMAGE' && imageSrcMap[resource.fileRobustagno.id]" :src="imageSrcMap[resource.fileRobustagno.id]" alt="" class="preview-image"/>
                  <div v-else @click=clickOnDownloadBtn() class="textual-link">{{getValue('fileRobustagno.fileName')}}</div>
                </div>
              </div>
              <div class="col-md-6" v-else>
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('Resource') }}</div>
                  <a :href="resource.urlLink" target="_blank"> {{ getValue('urlLink') }}</a>
                </div>
              </div>

            </div>
          </b-card>
        </div>
      </div>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="false"
      :isFeminine="true"
      :selectedItem="resource"
      controllerName="resource"
      itemSingularName="resource"
      itemSingularNameUpp="Resource"
      @didDeleteItem="didDeleteItem()">
    </Item-delete-modal>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import DateField from '../../components/b122/editFields/DateField'
import ShowActions from '../../components/b122/ShowActions'
import ItemDeleteModal from '../../components/b122/ItemDeleteModal'

export default {

  name: 'ResourceShow',

  components: {
    BackArrow,
    DateField,
    ShowActions,
    ItemDeleteModal
  },

  data () {
    let isAuthorized = this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin
    return {
      resourceId: this.$route.params.resourceId,
      resource: {},
      allowDelete: isAuthorized,
      allowEdit: isAuthorized,
      allowDownload: false,
      imageSrcMap: {}
    }
  },

  mounted () {
    this.fetchData()
  },

  computed: {
    getValue () {
      return (path) => {
        const properties = path.split('.')
        let value = properties.reduce((prev, curr) => {
          return prev && prev[curr] ? prev[curr] : null
        }, this.resource)
        return value !== null ? value : 'N/A'
      }
    }
  },

  methods: {
    async loadImagePreview(fileId, fileUrl) {
      if (this.imageSrcMap[fileId]) return

      const res = await api.get(fileUrl, {
        responseType: 'blob'
      })

      const ct = (res.headers && res.headers['content-type']) || ''
      if (!ct.startsWith('image/')) {
        throw new Error('La réponse n’est pas une image (content-type=' + ct + ')')
      }

      const blobUrl = window.URL.createObjectURL(res.data)
      this.$set(this.imageSrcMap, fileId, blobUrl)
    },

    async fetchData () {
      if (this.resourceId) {
        await this.fetchResource()
      }
    },

    async fetchResource () {
      try {
        const response = await api.get('/resource/' + this.resourceId)
        this.resource = response.data

        // Charger l'aperçu uniquement si c'est une image
        if (
          this.resource &&
          this.resource.fileRobustagno &&
          this.resource.fileRobustagno.fileType === 'IMAGE' &&
          this.resource.fileRobustagno.id &&
          this.resource.fileRobustagno.fileUrl
        ) {
          await this.loadImagePreview(
            this.resource.fileRobustagno.id,
            this.resource.fileRobustagno.fileUrl
          )
        }
      } catch (e) {
        console.error('fetchResource error', e)
      }
    }
    ,

    async clickOnDownloadBtn () {
      const res = await api.get(this.resource.fileRobustagno.fileUrl, {
        responseType: 'blob'
      })

      var disposition = res.headers['content-disposition'] || ''
      var filename = 'download'

      if (disposition) {
        var match = disposition.match(/filename="?([^"]+)"?/i)
        if (match && match[1]) {
          filename = match[1]
        }
      }

      var blobUrl = window.URL.createObjectURL(res.data)
      var a = document.createElement('a')
      a.href = blobUrl
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(blobUrl)
    },

    clickOnEditBtn () {
      this.$router.push({
        name: 'ResourceEdit',
        params: {
          resourceId: this.resource.id
        }
      })
    },

    clickOnDeleteBtn () {
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteItem () {
      this.$router.push({
        name: 'ResourceIndex'
      })
    }
  }
}
</script>

<style scoped>
.preview-image {
  width: 100%;
  height: 175px;
  object-fit: contain;
  border-radius: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/views/resource/ResourceShow.vue